// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"__ssWL8fkmuPLyEN"};


//////////////////
// WEBPACK FOOTER
// ./app/components/User/UserPageWrapper.pcss
// module id = 514
// module chunks = 1